import React from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@hooks/useAuth';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { APP_NAME } from '@/config/appConfig';
import Icon from '@components/common/atoms/Icon';

const LandingFooter: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const primaryCtaLabel = isAuthenticated ? 'Go to Dashboard' : 'Sign In';
  const goToApp = () => navigate(isAuthenticated ? '/dashboard' : '/login');

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Box component="footer" className="border-t border-slate-200/70 bg-white dark:border-slate-800/70 dark:bg-slate-950">
      <Box className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-8 sm:px-6 md:flex-row lg:px-8">
        <Box className="flex items-center gap-3">
          <Box className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-600 to-purple-600 shadow-lg shadow-indigo-500/30">
            <Icon name="Users" size={18} className="text-white" />
          </Box>
          <Box>
            <Typography component="span" className="block text-sm font-bold">{APP_NAME}</Typography>
            <Typography component="span" className="block text-xs text-slate-500 dark:text-slate-400">
              Empowering People. Elevating Organisations.
            </Typography>
          </Box>
        </Box>

        <Box className="flex items-center gap-6 text-sm text-slate-500 dark:text-slate-400">
          <Button onClick={() => scrollTo('features')} className="hover:text-indigo-600 dark:hover:text-indigo-400">
            Features
          </Button>
          <Button onClick={() => scrollTo('benefits')} className="hover:text-indigo-600 dark:hover:text-indigo-400">
            Benefits
          </Button>
          <Button onClick={() => scrollTo('contact')} className="hover:text-indigo-600 dark:hover:text-indigo-400">
            Contact
          </Button>
          <Button onClick={goToApp} className="font-semibold text-indigo-600 hover:underline dark:text-indigo-400">
            {primaryCtaLabel}
          </Button>
        </Box>
      </Box>
      <div className="border-t border-slate-200/70 py-4 text-center text-xs text-slate-400 dark:border-slate-800/70 dark:text-slate-500">
        © {new Date().getFullYear()} {APP_NAME}. All rights reserved.
      </div>
    </Box>
  );
};

export default LandingFooter;
